import React from 'react'
import cx from 'classnames'
import { Image03 } from 'blaze-ui/icons/24'
import { ConditionalWrapper } from 'common/ConditionalWrapper/ConditionalWrapper'
import { DesignChannel } from 'components/NewFileModal/Types'
import { EditInDesignerOverlay } from '../../components/EditInDesignerOverlay/EditInDesignerOverlay'
import Styles from './MediaRenderer.module.scss'

interface BlankMediaPlaceholderProps {
  className?: string
  showHoverActionOverlay?: boolean
  almanacFileKey?: string
  channel?: DesignChannel
  caption?: string
  onClose?: () => void
  aspectRatio?: number | string
}

export const BlankMediaPlaceholder: React.FC<BlankMediaPlaceholderProps> = ({
  className,
  showHoverActionOverlay = false,
  almanacFileKey,
  channel,
  caption,
  onClose,
  aspectRatio,
}) => {
  const placeholder = (
    <div className={cx(Styles.imagePlaceholder, className)}>
      <div className={Styles.imagePlaceholderIcon}>
        <Image03 size={42} />
      </div>
    </div>
  )

  const content =
    aspectRatio !== undefined ? <div style={{ width: '100%', aspectRatio }}>{placeholder}</div> : placeholder

  return (
    <ConditionalWrapper
      condition={showHoverActionOverlay && almanacFileKey}
      wrapper={(children) => (
        <EditInDesignerOverlay
          channel={channel ?? DesignChannel.Post}
          almanacFileKey={almanacFileKey as string}
          borderRadius={0}
          onClose={onClose}
          scrimOpacity={40}
          mediaObjects={[]}
          caption={caption}
        >
          {children}
        </EditInDesignerOverlay>
      )}
    >
      {content}
    </ConditionalWrapper>
  )
}
